module.exports = __webpack_public_path__ + "static/rituals-filmpje-2015-c1d7ad503384b034a5ad685524107ff2.mp4";